<template>
  <w-icon-wrapper
    :height='24'
    :width='20'
    icon-name='work-create-bill-icon'
    view-box='0 0 20 24'
  >
    <g
      id='_20_Rechnung_erstellen_Icon'
      data-name='20 Rechnung erstellen_Icon'
      transform='translate(-1.695)'
    >
      <path
        id='Pfad_55682'
        d='M15.695,0H1.7V24h20V6Zm0,2.828L18.867,6H15.695Zm4,19.172h-16V2h10V8h6Z'
        data-name='Pfad 55682'
        fill='currentColor'
      />
      <path
        id='Pfad_55683'
        d='M12.615,8.62h-1.59V9.91a2.625,2.625,0,0,0-1.38.77,2.532,2.532,0,0,0-.63,1.76,2.476,2.476,0,0,0,.65,1.75,4.212,4.212,0,0,0,1.9,1.05,3.068,3.068,0,0,1,1.08.55.807.807,0,0,1,.25.61.831.831,0,0,1-.29.68,1.44,1.44,0,0,1-.92.26,1.161,1.161,0,0,1-.89-.31,1.294,1.294,0,0,1-.3-.94v-.37H8.7v.37a2.878,2.878,0,0,0,.69,2.02,2.653,2.653,0,0,0,1.54.81v1.13h1.58V18.92a2.742,2.742,0,0,0,1.49-.74,2.46,2.46,0,0,0,.68-1.79,2.7,2.7,0,0,0-.27-1.21,2.576,2.576,0,0,0-.83-.92,5.581,5.581,0,0,0-1.44-.66,3.21,3.21,0,0,1-1.09-.54.815.815,0,0,1-.25-.64.9.9,0,0,1,.24-.69,1.111,1.111,0,0,1,1.49.08,1.659,1.659,0,0,1,.29,1.03v.38H14.6v-.38a3.245,3.245,0,0,0-.6-2.05,2.54,2.54,0,0,0-1.39-.87Z'
        data-name='Pfad 55683'
        fill='currentColor'
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconCreateBill' };
</script>
